// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Plaintext` component is used to show regular text, without any formatting options and ignoring html tags.
 * @since 0.0.42
 */
const Plaintext = _ref => {
  let {
    className,
    children,
    baseClassName = `${CLS_PREFIX}plaintext`
  } = _ref;
  return /*#__PURE__*/_jsx("pre", {
    className: classNames(baseClassName, className),
    children: children
  });
};
export default Plaintext;